import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {setUpdateButtonActiveStepToTrue, updateCounter} from '../../../../store/actions/main';
import {updateProductToMerklisteVordaecher,
        updateStepsVordaecher,
        updateDescriptionVordaecher,
        selectUploadDataVordaecher,
        updateAllVisitedStepsVordaecher
        } from '../../../../store/actions/vordaecher';
import Button from '@material-ui/core/Button';
import {Link} from 'react-router-dom';
import LaunchIcon from '@material-ui/icons/Launch';
import TextField from '@material-ui/core/TextField';
import DescriptionIcon from '@material-ui/icons/Description';
//import {PrintAngebot} from '../../../../module/printAngebot';

const Step_3 = (props) => {
    const [is_upload_data, updateUploadData] = useState('');
    const [validFile, updateValidFile] = useState(true);
    const [mbytes, updateMbytes] = useState(0);
    const [fileName, updateFileName] = useState('');
    const [descriptionData, updateDescriptionData] = useState('');
    let empty_file = '';
    let [is_merkliste, isMerklisteUpdate] = useState(false);
    // let [printMainTitel, setPrintMainTitel] = useState('');
    // let [printMuster, setPrintMuster] = useState('');
    // let [printDimensions, setPrintDimensions] = useState('');
    // let isMuster = true;
    // let isVordach = true;
    // let [printPfosten, setPrintPfosten] = useState('');
    // let [printPrice, setPrintPrice] = useState(0);
    // let [printProduct, setPrintProduct] = useState('');
    // let [printGlasart, setPrintGlasart] = useState('');


    useEffect(() => {
      updateItems();
    })

   const updateItems = () => {
    const {isUploadData, description, file} = props.data[props.modell_index].data_description[0];
    let is_merkliste = props.data[props.modell_index].is_merkliste;
    let addButtonMerkliste = document.querySelector('.addButtonMerkliste');
    let data_upload_button = document.querySelector('.data_upload_button');
    let toWishListButton = document.querySelector('.toWishListButton');

    if (isUploadData) {
        data_upload_button.classList.add('check');
    } else {
        data_upload_button.classList.remove('check');
    }

    updateUploadData(isUploadData);
    updateDescriptionData(description);
    isMerklisteUpdate(is_merkliste);

    if (file) {
        updateFileName(file.name);
        const bytesToMegaBytes = file.size / (1024 ** 2);
        updateMbytes(bytesToMegaBytes);
    }

      if(is_merkliste) {
        addButtonMerkliste.classList.add('check');
        toWishListButton.classList.add('check');
      } else {
        toWishListButton.classList.remove('check');
        addButtonMerkliste.classList.remove('check');
      }

      //update steps
      props.updateSteps(2);

      props.setUpdateButtonActiveStepToTrue();
      props.updateAllVisitedSteps();
      //printItems();
   }

    // const printItems = () => {
    //     let mainTitel = props.data[props.modell_index].product_img;
    //     let product = props.data[props.modell_index].titel;
    //     let muster = props.data[props.modell_index].product_img;
    //     let pfosten = props.data[props.modell_index].pfosten;
    //     let dimensions = props.data[props.modell_index].dimensions[0];
    //     let price = props.data[props.modell_index].price;
    //     let glasart = props.data[props.modell_index].glasart;

    //     setPrintMainTitel(mainTitel);
    //     setPrintMuster(muster);
    //     setPrintDimensions(dimensions);
    //     setPrintPrice(price);
    //     setPrintProduct(product);
    //     setPrintGlasart(glasart);
    //     setPrintPfosten(pfosten);
    // }

    // const selectUploadData = ev => {
    //     ev.preventDefault();
    //     let reader = new FileReader();
    //     let file = ev.target.files[0];

    //     reader.onloadend = () => {
    //     let uploadObject = {
    //         file: file,
    //         image: reader.result
    //     }
    //     props.selectUploadData(uploadObject);
    //     updateItems();
    //     }
    //     reader.readAsDataURL(file);
    // }

    const selectUploadData = ev => {
        ev.preventDefault();
        let file = ev.target.files[0];
        console.log('FILE', file);

        const fileSize = file.size;
        const bytesToMegaBytes = fileSize / (1024 ** 2);

        if (bytesToMegaBytes > 5) {
            updateValidFile(false);
        } else {
            updateValidFile(true);
            updateMbytes(bytesToMegaBytes);
            updateFileName(file.name);
        }

        let uploadObject = {
            file: file
         }

         props.selectUploadData(uploadObject);
         updateItems();

    }

    const updateDescription = ev => {
        let description = ev.target.value;
        props.updateDescription(description);
        updateItems();
    }

   const updateProductToMerkliste = () => {
        props.updateProductToMerkliste();
        updateItems();
       if(is_merkliste)  props.updateCounter('dec');
       else  props.updateCounter('inc');
   }


   return (
    <div className="step_wrapper">
    <h2 className='step_header'>Hier können Sie uns Ihr Anliegen mit einer detalierten Beschreibung und ggf. einer Skizze mitteilen.</h2>
    <div className="step_icon_wrapper">
        <TextField
            className="outlined-multiline-static textfield_multiline"
            type="text"
            label="Ihr Anliegen:"
            rowsMax={10}
            multiline
            variant="outlined"
            value={descriptionData}
            name="description"
            onChange={updateDescription}
            >
        </TextField>
        <div className="merkliste_button_wrapper">
            <Button  className='data_upload_button' component="label" startIcon={<DescriptionIcon />}>
                {is_upload_data?
                <span>Datei ausgewählt<br/>({fileName.substring(0, 14)+'...'} {mbytes.toFixed(2)} MB)</span>
                :
                <span>Datei auswählen<br/>(max 5MB)</span>
                }
                <input id='myfileinput' name='productimage' className='upload_file_zaun' type="file" onChange={selectUploadData} value={empty_file} hidden />
            </Button>
            {!validFile && <span style={{color:'red', margin:'10px 0'}}>Ihre Datei ist zu groß für das Zieldateisystem</span>}
            {/* <PrintAngebot
                product={printProduct}
                mainTitel={printMainTitel}
                muster={printMuster}
                isMuster={isMuster}
                dimensions={printDimensions}
                pfosten={printPfosten}
                price={printPrice}
                glasart={printGlasart}
                isVordach={isVordach}
                className='print_button'
            /> */}
            <Button className='addButtonMerkliste' onClick={updateProductToMerkliste}>{is_merkliste?'aus der Merkliste entfernen':'in die Merkliste hinzufügen'}</Button>
            <Link className="link" to={is_merkliste?'/merkliste':'#'}><Button className='toWishListButton'>Zur Merkliste <LaunchIcon className='launch-icon' /></Button></Link>
        </div>

    </div>
</div>
   )
}

const mapStateToProps = state => {
    return {
        modell_index: state.vordaecherReducer.modell_index,
        data: state.vordaecherReducer.data
    }
}

const mapDispatchToProps = dispatch =>  {
   return {
      setUpdateButtonActiveStepToTrue: () => dispatch(setUpdateButtonActiveStepToTrue()),
      updateCounter: ev => dispatch(updateCounter(ev)),
      updateProductToMerkliste: () => dispatch(updateProductToMerklisteVordaecher()),
      updateSteps: ev => dispatch(updateStepsVordaecher(ev)),
      updateDescription: ev => dispatch(updateDescriptionVordaecher(ev)),
      selectUploadData: ev => dispatch(selectUploadDataVordaecher(ev)),
      updateAllVisitedSteps: () => dispatch(updateAllVisitedStepsVordaecher())
   }
}


export default connect(mapStateToProps, mapDispatchToProps)(Step_3);
